import { useState } from "react";
import PropTypes from "prop-types";
import { useComponentVisible } from "../../../hooks";
import { titleCase } from "@lib/formatString";
import { FilterListMobile } from "./FilterListMobile";
import { COLOUR_TAGS } from "../constants";
import { CloseIcon } from "@components/Icon";
import styles from "./styles/FilterMobile.module.css"

export const FilterMobile = ({
  activeFilters,
  showFilterMenu,
  setShowFilterMenu,
  filterLabels,
  filteredValues,
  onChange,
}) => {
  // Hook that alerts clicks outside of the passed ref
  const { ref } = useComponentVisible(() => setShowFilterMenu(false));
  const [selectedFilter, setSelectedFilter] = useState("");

  const handleSelectFilter = value => {
    setSelectedFilter(value);
    setShowFilterMenu(false);
  }

  const title = (key) => {
    if (key === COLOUR_TAGS) return "Colours";
    return `${titleCase(key)}s`;
  }

  const containerStyles = `
    ${styles.container}
    ${showFilterMenu ? styles.showContainer : ''}
  `;

  const Header = () => {
    return (
      <header className={styles.heading}>
        <h4>Filter By:</h4>
        <button
          onClick={() => setShowFilterMenu(false)}
          aria-label="close filter menu"
        >
          <CloseIcon />
        </button>
      </header>
    )
  };

  const MenuList = () => {
    return (
      <ul>
        {activeFilters.map(filter => (
          <MenuListItem key={filter} filter={filter} />
        ))}
      </ul>
    )
  };

  const MenuListItem = ({ filter }) => {
    return (
      <li>
        <button
          className={styles.button}
          onClick={() => handleSelectFilter(filter)}
        >
          <p>{title(filter)}</p>
          <p>+</p>
        </button>
      </li>
    )
  };

  const ListOptions = () => {
    return (
      <>
        {activeFilters.map((filter) => {
          return (
            <div key={filter}>
              {selectedFilter === filter && (
                <FilterListMobile
                  filterName={filter}
                  filterLabels={[...filterLabels[filter]]}
                  filteredValues={filteredValues[filter]}
                  onChange={onChange}
                  setSelectedFilter={setSelectedFilter}
                  setShowFilterMenu={setShowFilterMenu}
                />
              )}
            </div>
          )
        })}
      </>
    )
  }

  return (
    <>
      <div className={containerStyles} ref={ref}>
        <Header />
        <MenuList />
      </div>
      <ListOptions />
    </>
  );
};

FilterMobile.propTypes = {
  filterLabels: PropTypes.shape({
    colour: PropTypes.objectOf(PropTypes.string),
    colourTags: PropTypes.objectOf(PropTypes.string),
    size: PropTypes.objectOf(PropTypes.string),
    type: PropTypes.objectOf(PropTypes.string),
  }),
  filteredValues: PropTypes.shape({
    colour: PropTypes.array,
    colourTags: PropTypes.array,
    size: PropTypes.array,
    type: PropTypes.array,
  }),
  onChange: PropTypes.func,
  showFilterMenu: PropTypes.bool,
  setShowFilterMenu: PropTypes.func,
  activeFilters: PropTypes.arrayOf(PropTypes.string)
};
